"use client";

import Grid from "@mui/material/Grid2";
import { useFormikContext } from "formik";
import React, { useEffect } from "react";

import MDBox from "@/components/atoms/MDBox";
import { CampaignFormData } from "@/components/screens/CampaignFormPage/types";
import { ICampaignTemplate } from "@/interfaces/campaign-template.interfaces";
import { CampaignFormPageMessages } from "@/messages/campaigns/campaign-form-page.messages";
import { CampaignType } from "@/types/campaign.types";

import CalendarComponent from "./components/Calendar";
import CampaignImage from "./components/CampaignImage";
import CampaignInfo from "./components/CampaignInfo";
import Introduction from "./components/Introduction";

type Props = {
  messages: CampaignFormPageMessages;
  setTIndex: React.Dispatch<React.SetStateAction<number>>;
  template: ICampaignTemplate;
};

function CampaignDataTab({ messages, setTIndex, template }: Props) {
  const { values, setFieldValue } = useFormikContext<CampaignFormData>();

  useEffect(() => {
    if (values.type !== undefined && template) {
      let index = 0;
      let templateText = template.text;

      // Definir o template correto baseado no tipo de campanha
      if (values.type === CampaignType.PromotionalPrice) {
        index = 1; // Template Preço Promocional (segundo template)
        templateText = "Olá!\n\nUse o código #CAMPAIGNCODE# e acesse o desconto para os produtos desta campanha.";
      }
      if (values.type === CampaignType.DiscountCoupon) {
        index = 0; // Template Cupom de Desconto (primeiro template)
        templateText = "Olá!\n\nUse o código #CAMPAIGNCODE# para obter #DISCOUNT#% de desconto adicional em toda a sua compra.";
      }

      const formatTemplate = {
        ...template,
        id: values.isEditing ? values.template.id : 0,
        text: templateText,
      };

      setTIndex(index);
      setFieldValue("text", templateText);
      setFieldValue("template", formatTemplate);
    }
  }, [setFieldValue, setTIndex, template, values.isEditing, values.template.id, values.type]);

  return (
    <MDBox mt={4}>
      <Grid container spacing={3}>
        <Grid size={{ xs: 12, lg: 4 }}>
          <MDBox height="100%">
            <CampaignImage messages={messages} />
          </MDBox>
        </Grid>

        <Grid size={{ xs: 12, lg: 8 }}>
          <MDBox height="100%">
            <CampaignInfo messages={messages} />
          </MDBox>
        </Grid>

        <Grid size={{ xs: 12, lg: 4 }}>
          <Introduction messages={messages} />
        </Grid>

        <Grid size={{ xs: 12, lg: 8 }}>
          <CalendarComponent messages={messages} />
        </Grid>
      </Grid>
    </MDBox>
  );
}

export default CampaignDataTab;
